// Cost | Margin | Sale/Price | Qty/Dur | Disc | Sub | VAT | Total | Remove
const SHARED_COLUMNS = '76px 66px 76px 66px 56px 76px 64px 88px 112px';
// Remove is only its icon here: in the job drawer, a word and the cart would leave the fields next to no room.
const SHARED_COLUMNS_SMALL = '66px 58px 66px 60px 50px 66px 56px 80px 60px';

const DISCOUNT_COLUMN = 4;
const FIRST_TOTALS_COLUMN = 5;
const LAST_TOTALS_COLUMN = 7;

interface IServiceGrid {
  isSmallDesktop: boolean;
  /** The row's own columns before the shared ones: the space left over goes to these. */
  leadingColumns: string;
  showDiscount: boolean;
  showTotals: boolean;
}

/**
 * The grid of a service's row and of its parts' rows. They share every column from Cost on, and drop the
 * same ones, so what is left lines up from one row to the next.
 */
export const serviceGrid = ({ isSmallDesktop, leadingColumns, showDiscount, showTotals }: IServiceGrid) => {
  const sharedColumns = (isSmallDesktop ? SHARED_COLUMNS_SMALL : SHARED_COLUMNS)
    .split(' ')
    .filter(
      (_, i) =>
        (showDiscount || i !== DISCOUNT_COLUMN) &&
        (showTotals || i < FIRST_TOTALS_COLUMN || i > LAST_TOTALS_COLUMN)
    )
    .join(' ');

  return {
    display: 'grid',
    gridTemplateColumns: `${leadingColumns} ${sharedColumns}`,
    gap: isSmallDesktop ? 6 : 8,
  };
};
